import Axios from "axios";
import apm from "../rum";

import * as localStorageService from "./localStorageService";
import { LocalStorageKeys } from "../constants/localStorageKeys";


//default configuration for without auth token
export const getDefaultConfig = () => {
    var config = {};
    config = {
        "Content-Type": "application/json",
    };
    return config;
};

//default configuration for without auth token
export const downloadExcelConfig = () => {
    var config = {};
    config = {
        "Content-Type": "application/json",
        responseType: "arraybuffer",
    };
    return config;
};

//config with auth token
export const getConfig = () => {
    var config = {};
    const token = localStorageService.getValue(LocalStorageKeys.AuthToken) ? `Bearer ${localStorageService.getValue(LocalStorageKeys.AuthToken)}` : "";

    config = {
        "Content-Type": "application/json",
        Authorization: `${token}`,
    };

    return config;
};

//post api call
export const Post = (url, payload, isFormPost = false, headerObj) => {
    let transaction = apm.startTransaction(url, "API_CALL_POST"); //APM transaction

    let service = Axios.post(url, payload, { headers: isFormPost ? headerObj : getConfig() });

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();

    return service;
};

export const PostWithWebPlatform = (url, payload) => {
  let transaction = apm.startTransaction(url, "API_CALL_POST");

  const service = Axios.post(url, payload, {
    headers: {
      ...getConfig(),
      Platform: "web",
    },
  });

  transaction = apm.getCurrentTransaction();
  if (transaction) transaction.end();

  return service;
};


//post api call
export const Upload = (url, payload, config) => {
    const token = localStorageService.getValue(LocalStorageKeys.AuthToken) ? `Bearer ${localStorageService.getValue(LocalStorageKeys.AuthToken)}` : "";
    let transaction = apm.startTransaction(url, "API_CALL_POST"); 

    config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        "Authorization": `${token}`
      };
   
    let service = Axios.post(url, payload, config);

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();

    return service;
};

// put api call
export const Put = (url, payload, isFormPost = false, headerObj) => {
    let transaction = apm.startTransaction(url, "API_CALL_PUT"); //APM transaction

    let service = Axios.put(url, payload, { headers: isFormPost ? headerObj : getConfig() });

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();

    return service;
};

//get api call
export const Get = (url) => {
    var transaction = apm.startTransaction(url, "API_CALL_GET"); //APM transaction

    let service = Axios.get(url, { headers: getConfig() });

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();
    return service;
};

//post api call
export const Download = (url, payload) => {
    let transaction = apm.startTransaction(url, "API_CALL_POST"); //APM transaction

    let service = Axios.post(url, payload, downloadExcelConfig());

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();

    return service;
};

//post api call
export const DownloadGet = (url) => {
    let transaction = apm.startTransaction(url, "API_CALL_POST"); //APM transaction

    let service = Axios.get(url, downloadExcelConfig());

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();

    return service;
};

//Post file
export const PostFile = (url, payload,config) => {
    let transaction = apm.startTransaction(url, "API_CALL_POST"); //APM transaction
    config.headers = {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      };
    config.maxRedirects= 0;
    let service = Axios.post(url, payload, config);

    transaction = apm.getCurrentTransaction(); //End APM trasnsaction
    if (transaction) transaction.end();

    return service;
};

//Post file with AUTH in header
export const PostFileAuth = (url, payload, config) => {
  let transaction = apm.startTransaction(url, "API_CALL_POST"); //APM transaction
  config.headers = {
    ...getConfig(),
    ...(config.headers || {}),
    "Content-Type": "multipart/form-data",
  };
  config.maxRedirects = 0;
  let service = Axios.post(url, payload, config);

  transaction = apm.getCurrentTransaction(); //End APM trasnsaction
  if (transaction) transaction.end();

  return service;
};